import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';
import { fetchTeamEvents } from './calendarThunks.js';

export const fetchPendingRequests = createAsyncThunk(
    'pendingRequests/fetch',
    async ({ page }, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const perPage = state.general.settings.perPage;
            const { maxPageNumber, list } = await API.pendingRequests.get(page, perPage);

            const existingList = state.pendingRequests.list || [];

            return {
                maxPageNumber,
                list: page ? [...existingList, ...list] : list,
            };
        } catch (e) {
            notification.error({
                message: 'Error when fetching pending requests',
                description: e.message || 'Unknown error',
            });
            return rejectWithValue(e.message);
        }
    },
);

export const approvePendingRequest = createAsyncThunk(
    'pendingRequests/approve',
    async ({ requestId, requestType, requestStatus }, { dispatch, rejectWithValue }) => {
        try {
            const apiSection = requestType === 'vacation' ? 'vacations' : 'workingTime';
            await API[apiSection].approve(requestId);

            notification.success({
                message: 'Success',
                description: `${requestType} was approved`,
            });

            dispatch(fetchTeamEvents());

            return {
                approvedRequestId: requestId,
                approvedRequestStatus: requestStatus,
            };
        } catch (e) {
            notification.error({
                message: e.type || `Error when trying to approve ${requestType}`,
                description: e.message,
            });
            return rejectWithValue(e.message);
        }
    },
);

export const denyPendingRequest = createAsyncThunk(
    'pendingRequests/deny',
    async ({ requestId, requestType, requestStatus }, { dispatch, rejectWithValue }) => {
        try {
            const apiSection = requestType === 'vacation' ? 'vacations' : 'workingTime';
            await API[apiSection].deny(requestId);

            notification.success({
                message: 'Success',
                description: `${requestType} was declined`,
            });

            dispatch(fetchTeamEvents());

            return {
                deniedRequestId: requestId,
                deniedRequestStatus: requestStatus,
            };
        } catch (e) {
            notification.error({
                message: e.type || `Error when trying to deny ${requestType}`,
                description: e.message,
            });
            return rejectWithValue(e.message);
        }
    },
);
